<template>

  <div dir="ltr">
    <!--    <b-dropdown :text="item.name" variant="transparent" class="m-0 p-0"
                    v-if="item.children.length!==0">

          <b-nav-item class="px-3" :href="child.url" v-for="child in item.children" :key="child.id">
            {{ child.name }}&MediumSpace;
            <m-icon class="m-0" :icon="child.icon_class"/>
          </b-nav-item>

        </b-dropdown>-->

    <a :href="item.url" class="px-3 nav-item text-decoration-none" >
      {{ item.name }} &MediumSpace;
      <m-menu-icon-manager class="m-0" :item-icon="item.icon_class"/>
    </a>

  </div>

</template>

<script>
import mMenuIconManager from "../../Menu/MenuIconManager.vue";

export default {
  name: "NavMenuItem",
  components: {mMenuIconManager},
  props: ['item'],
}
</script>

<style scoped>

</style>
